import { getDahuangImage, getDahuangMusic } from './dahuangAssets';

// 《回到大荒》预告站文案。
// 取材自 Ammonia 工程 docs/头脑风暴/宣传文案.md 与 docs/头脑风暴/前期剧情.md。

export const dahuangLinks = {
  // 预上线阶段，商店与预约入口暂未开放，先占位，后续填真实链接。
  taptap: 'https://l.taptap.cn/L1jztjMx?channel=rep-rep_y9wsdfaylfe',
  douyin: '',
  forum: '',
  rebirthHoarder: '/rebirth-hoarder',
  privacyPolicy: '/dahuang/privacy-policy',
  userAgreement: '/dahuang/user-agreement',
};

export const dahuangHero = {
  eyebrow: 'LIGHTSLICE · 生存系列新作',
  title: '回到大荒',
  titleFull: '回到大荒',
  subtitle: '现代科技降维打击，把一场古代大饥荒，玩成最顶级的逆袭爽剧。',
  description:
    '大旱三年，赤地千里。你一睁眼，成了荒年里快饿死的古代流民——好在脑子里装满了现代科学知识。造化肥、种红薯、做空粮商、筑水泥堡垒，从被地主欺压的流民，一路逆袭成拥有整座科技庄园的「天命仙师」。',
  status: '即将上线',
  statusNote: 'TapTap 与抖音小游戏 · 敬请期待',
  background: getDahuangImage('hero'),
  poster: getDahuangImage('promo_1'),
  badges: ['生存经营', '科幻穿越', '策略建造', '知识降维', '古代逆袭'],
};

export const dahuangFeatures = [
  {
    id: 'agri',
    icon: '🌾',
    title: '降维农业',
    subtitle: '化肥与高产作物的奇迹',
    description:
      '古代一亩地只产一两百斤？土法堆肥、尿素提炼，用现代红薯、土豆让干瘪的盐碱地长出箩筐大的红薯——一亩三千斤，在饥荒年代手握最硬的通货。',
    mechanic: '土壤改良 × 良种选育 × 肥料配方，六块对照实验田把盐碱死地玩成高产粮仓。',
    storyHook: '「后山盐碱荒滩连草都不长？」—— 沈凌一锄头下去，挖出一串碗口粗的红薯。',
    image: getDahuangImage('promo_2'),
  },
  {
    id: 'market',
    icon: '📈',
    title: '平准粮市',
    subtitle: '把地主逼到破产的金融局',
    description:
      '古代粮商囤积居奇？用现代金融学发行期票、虚实结合。天灾前高位做空，天灾后低价抄底，未费一兵一卒，用做空镰刀合法吞并黑心粮商与地主老财的万亩良田。',
    mechanic: '恐慌指数 + 粮价曲线 + 期票合约，气象做空局让金融成为最锋利的收割刀。',
    storyHook: '「天要变了。」—— 第一滴雨落上刘大户的血红核桃，整座临安粮市应声崩盘。',
    image: getDahuangImage('promo_3'),
  },
  {
    id: 'defense',
    icon: '🏰',
    title: '科技防守',
    subtitle: '水泥堡垒与物理御寇',
    description:
      '烧制波特兰水泥筑起坚不可摧的庄园围墙，拉带刺铁丝网、埋设无烟黑火药地雷。五百悍匪夜袭，用现代工业与化学在废土上完成一场无情的降维打击。',
    mechanic: '材料链（石灰石 / 黏土 / 铁矿渣） → 水泥工坊 → 围墙 / 拒马 / 火药桶防御节点。',
    storyHook: '「火药负责制造声音和火光，他们自己的想象力负责补足剩下的杀伤。」',
    image: getDahuangImage('promo_4'),
  },
  {
    id: 'gossip',
    icon: '💬',
    title: '天机风评',
    subtitle: '古代版「朋友圈」看人间百态',
    description:
      '亲历村民态度的 180 度大转变：从嘲讽你「饿昏了胡言乱语」，到「求仙师赐予种子」，再到官府衙役登门跪求你施舍口粮。风评系统让每一步逆袭都掷地有声。',
    mechanic: '村头茶馆闲话每日刷新，民望从「厌恶」到「依附」，声望直接兑换劳力、情报与规矩。',
    storyHook: '「他们未必已经喜欢我们……他们开始需要我们。」—— 被需要，才是权力的开端。',
    image: getDahuangImage('promo_1'),
  },
];

export const dahuangCharacters = [
  {
    id: 'shenling',
    name: '沈凌',
    role: '玩家 / 现代化工工程师',
    camp: '主角团',
    voice: 'shenling',
    description:
      '原主是大荒村败家赌徒，今生却换成冷静高效的现代理科生。用分子、能量守恒与工业党思维，把饥荒时代拆成一道道可以求解的工程题。',
    fullBio:
      '穿越即地狱开局：没有系统、没有空间、没有老爷爷。原主把全家最后一升麦麸输上了赌桌，妻子持棍护妹，妹妹饿得不敢哭。他把这场饥荒当成一道「能解的工程题」—— 过滤毒土、改盐碱地、种红薯、筑水泥墙、做空粮商、埋火药地雷。从快饿死的败家子，一路把破屋拼成大荒时代第一座科技庄园。',
    image: getDahuangImage('npc_shenling_half'),
  },
  {
    id: 'guqingyi',
    name: '顾清漪',
    role: '原配之妻',
    camp: '主角团',
    voice: 'guqingyi',
    description:
      '落魄秀才之女，知书达理、清傲坚韧。她对沈凌的信任不是一夜倒戈，而是在草根糊糊、红薯丰收与庄园崛起里慢慢冰雪消融。',
    fullBio:
      '嫁给赌徒是她命运的最低点。她削尖木棍护着丫丫，把最后一丝尊严钉在「你来我就扎穿」的沉默里。可沈凌醒来后没再抢一粒粮、没再动一根指头 —— 他开始和土、和毒、和碱地较劲。她看着草根糊糊冒出热气、红薯在盐碱荒滩破土、水泥墙一寸寸长高，眼里的戒备被一锅粥、一串红薯、一场雨慢慢融开。「她眼里不是震惊，也不是怀疑。是第一次真正的信任。」',
    image: getDahuangImage('npc_guqingyi_half'),
  },
  {
    id: 'suwan',
    name: '苏婉',
    role: '金牌大管家',
    camp: '主角团',
    description:
      '丝绸巨贾之女，在逃荒路上被一碗红薯粥救回。通算学、精账目，学会双分录记账与杠杆粮市后，成为庄园最锋利的财政副官。',
    fullBio:
      '府城苏家绸缎庄的账房天才，叛军破城后攥着断玉扣昏迷在雪地里。沈凌把她背回家，顾清漪把外衣披在她身上。她用一夜看完那张「红薯用途分配表」，识出「军粮账、商队账、工坊账合在一起」的格局 —— 从此仓库有了五类分科、工人有了木牌记工、粮市行情被她拨算盘拨成残影。高端财务人才，逃荒路上主动投了简历。',
    image: getDahuangImage('npc_suwan_half'),
  },
  {
    id: 'shenyaya',
    name: '沈丫丫',
    role: '待护之妹',
    camp: '主角团',
    voice: 'shenyaya',
    description:
      '八岁的亲妹妹，曾因饥饿和原主的拳脚缩在角落。她从害怕哥哥，到抱着第一串红薯笑出眼泪，是前期最直接的亲情守护驱动力。',
    fullBio:
      '八岁。胳膊细得像柴枝，肚子鼓得吓人，缩在床脚连看哥哥一眼都在发抖，「丫丫不饿了，丫丫今天不吃粮食了」。她用一碗草根糊糊把「说真话不会挨打」这件事重新学会；她第一个发现荒滩冒绿，尖叫着跑回来差点被门槛绊倒；丰收那天她扑过去想抱最大的红薯，红薯没动，自己先一屁股坐进土里。她是沈凌所有「不能拿孩子换收成」的规矩的理由。',
    image: getDahuangImage('npc_shenyaya_half'),
  },
  {
    id: 'tieniu',
    name: '张铁牛',
    role: '前期打手 / 庄园防卫队长',
    camp: '主角团',
    description:
      '北方逃难来的流民军汉，被以工代赈救回尊严。前期是沈凌最可靠的拳头，后期修水泥墙、埋黑火药地雷、操练护卫队。',
    fullBio:
      '饿得只剩骨架的北方军汉，偷半筐红薯干被抓住时哭得撕心裂肺：「我娘快饿死了！就一点！」沈凌没罚他，把偷来的粮倒进大锅熬粥。「给你自己挣命。」他从墙下挥锄砸向水泥墙 —— 锄口崩裂，墙面只掉一点灰。从此「铁牛」成了庄园第一柄拳头，抡锄、埋雷、操练。',
    image: getDahuangImage('npc_tieniu_half'),
  },
  {
    id: 'hanyan',
    name: '寒烟',
    role: '侠客 / 中后期主角团',
    camp: '主角团',
    description:
      '来去如风的蒙面女侠，擅长潜行、探路与夜袭。中后期加入庄园后，替沈凌处理官道暗线与乱世江湖里的脏活。',
    fullBio:
      '没人见过她摘下面纱。她像一阵不带声的风掠过黑风山的夜哨，把探子的靴底地图送到雷横手里。中后期庄园成了灯塔，也招来了江湖的目光 —— 那些县衙公文办不了、护卫队名册不记录的事，由寒烟在官道暗线里替沈凌了结。',
    image: getDahuangImage('npc_hanyan_half'),
  },
  {
    id: 'linxiao',
    name: '林骁',
    role: '侠客 / 中后期主角团',
    camp: '主角团',
    description:
      '冷峻寡言的江湖剑客，讲义气也讲规矩。中后期成为主角团的机动战力，负责护送商队、清剿匪患与保护科技庄园外线。',
    fullBio:
      '剑法极快，话极少。商队过黑风山外线、粮市银两押运、庄园外围巡逻 —— 只要林骁在阵，乱刀就挨不到粮车。他不问沈凌的「天机」是真是假，只管一件事：规矩立了，剑来守。',
    image: getDahuangImage('npc_linxiao_half'),
  },
  {
    id: 'liudahu',
    name: '刘成才',
    role: '刘大户 / 大荒村土皇帝',
    camp: '地方豪强',
    description:
      '垄断水源与粮食的宗族地主，肥头大耳却精于兼并。他贪婪地盯上红薯，也恐惧水泥庄园，最终会在粮市做空局里交出五代家积。',
    fullBio:
      '暗金寿字纹绸袍，手里盘着两颗血红核桃。他垄断村里的井，命家丁把跪着求水的老妇一脚踹开，按斤给命定价。他加价收粮、抵押田契、拉府城商号入局 —— 直到暴雨倾盆，粮价像被砍断的绳直坠而下。三天后他跪在庄园门前，地契抖成了秋风里的叶子，「沈…… 沈庄主，救我刘家一命。」',
    image: getDahuangImage('npc_liudahu_half'),
  },
  {
    id: 'zhaoguanjia',
    name: '赵瞎子',
    role: '赵管家 / 刘氏恶犬',
    camp: '地方豪强',
    description:
      '干瘪阴鸷、狐假虎威，是刘大户催租和刁难任务的执行人。玩家前期最直接的压迫感，常常从他那只白翳眼开始。',
    fullBio:
      '刘大户身边最忠的犬。他捧着假契约、盘着阴笑，把「后山自古是刘家佃田」念得字正腔圆 —— 契约是假的，印是真的，而解释权从来都在他主子手里。催租、刁难、在庄园门前冷笑，是他全部的本事；等刘家崩盘那天，他低着头，几乎埋进胸口。',
    image: getDahuangImage('npc_zhaoguanjia_half'),
  },
  {
    id: 'wanglaohan',
    name: '王铁锹',
    role: '王老汉 / 舆论风向标',
    camp: '大荒村民',
    description:
      '村头槐树下的破产老农，顽固、迷信又盲从。前脚赌沈凌种不出粮，后脚就在风评榜里惊呼红薯比头还大。',
    fullBio:
      '「你要是能在这鬼地方种出粮，我王老汉把村头青石磨盘吞了！」他是全村最大的嗓门、最响的嘲讽。能吃的东西只剩牙缝里的草根时，他的嘴还是硬的 —— 直到孙子夜里发烧，顾清漪送去半碗红薯粥。他欠了沈家一条命，收起棍子，低头递出那把旧铁锹：「能干活？能。那明天来。」',
    image: getDahuangImage('npc_wanglaohan_half'),
  },
  {
    id: 'lishen',
    name: '李婶',
    role: '长舌妇 / 悲喜晴雨表',
    camp: '大荒村民',
    description:
      '大荒村底层生态的喇叭，前期编排顾清漪和沈家，后期在妇女工坊带头晾晒红薯干，逢人便拜沈凌为活神仙。',
    fullBio:
      '大荒村的活广播。谁家灶熄了、谁家姑娘受了委屈，她的嘴比风还快 —— 「可怜顾秀才家的姑娘，嫁了这么个祸害」。可当她家两天没开灶、看着丫丫脸上有了血色，她端着空碗往沈家方向偷瞄的眼神先软了下去。后来她成了妇女工坊的领头，晒薯干、领粮、逢人便拜沈凌为活神仙。饥荒里先跪下的从来不是膝盖，是眼睛。',
    image: getDahuangImage('npc_lishen_half'),
  },
  {
    id: 'leiheng',
    name: '雷横',
    role: '独眼龙 / 黑风山大当家',
    camp: '黑风山',
    description:
      '盘踞黑风山十年的悍匪，带着五百亡命徒夜袭科技庄园。铁丝网与黑火药会让他第一次明白，乱世暴力也有代差。',
    fullBio:
      '他原是过路镖师，商队折在山口后流落大荒，被苏婉认出曾在府城有些名声。左眼一道旧疤，话不多，手里的刀极稳。他第一个被沈凌派出去「放探子回去报信」 —— 不是纵虎归山，是让山上的虎知道这里有肉。三更他敲响铜锣，拒马、陷坑、火药桶一齐给黑风山补了一课：乱世暴力，也有代差。',
    image: getDahuangImage('npc_leiheng_half'),
  },
];

export const dahuangStory = {
  eyebrow: 'THE SAGA',
  title: '一个现代理科生的饥荒建国史',
  description: '五幕层层递进的逆袭剧本，既是故事，也是玩法与关卡的推进主线。',
  chapters: [
    { index: 'I', title: '饿死的败家子与哭泣的妻妹', summary: '一朝穿越成濒死流民，用酸碱中和与物理过滤，把村民闻之色变的毒观音土做成救命糊糊。' },
    { index: 'II', title: '荒滩上的绿洲与邻里的讥讽', summary: '复合农家肥改良盐碱死地，半个红薯种出一亩三千斤，讥讽与厌恶尽数化作炽热崇拜。' },
    { index: 'III', title: '流民潮中的惊艳与庄园雏形', summary: '救下苏婉、推行「以工代赈」，烧制现代水泥，一座科技庄园在废土上拔地而起。' },
    { index: 'IV', title: '斗地主与割韭菜', summary: '气象预测 + 高杠杆做空，制造恐慌推高粮价再引爆雪崩，用金融镰刀吞并半个县城。' },
    { index: 'V', title: '土匪来袭，用火药和铁丝网物理超度', summary: '铁丝网、黑火药地雷与钢弩护卫队，五百悍匪灰飞烟灭，庄园完成向地方割据的蜕变。' },
  ],
};

// 剧情串讲「名场面」精选：7 张竖屏 CG × 7 段主线原文节选。
// cgKey 对应 dahuangAssets.getCgSaga 的键；节选自 docs/剧情文案/主线剧情文案设计V1.1.md。
export const dahuangSaga = [
  {
    index: 'I',
    title: '饿死的败家子，与护妹的妻子',
    cgKey: 'saga_000',
    excerpt:
      '「家里最后一升吊命的麦麸，昨天也被你偷去赌输了。你要是还想打她的主意换赌本，就先用这根木棍把我扎穿。」她眼里没有泪了。一个人真正绝望的时候，是哭不出来的。',
  },
  {
    index: 'II',
    title: '毒土、黑草根与第一锅草根糊',
    cgKey: 'saga_001',
    excerpt:
      '几个饿疯的灾民趴在地上，把灰白的泥土往嘴里塞。在我眼里，它不是食物，是过滤材料。「我要做的不是吃土，是把不能吃的东西，变成能吃的。」丫丫抱着碗，眼泪大颗大颗掉下来：「嫂嫂，是热的。」',
  },
  {
    index: 'VII',
    title: '刘家井前，第一场正面冲突',
    cgKey: 'saga_007',
    excerpt:
      '家丁抬脚要踹那个跪着磕头的老妇人。我伸手抓住了他的脚踝。「这是粮。」我把红薯饼扔过去。「哪来的？」「后家。」回去路上，顾清漪终于忍不住：「你就这么算了？」「记账了。刘家的第一笔。」',
  },
  {
    index: 'VIII',
    title: '红薯成藤，仓库第一次爆满',
    cgKey: 'saga_008',
    excerpt:
      '当那一串碗口粗的红薯从土里翻出来时，所有人都没了声音。风都像停了。丫丫扑过去想抱最大的那颗，红薯没动，自己先一屁股坐进了土里。「今天能吃饱吗？」「能。」「明天呢？」我看着满地翻出的红薯：「明天也能。」饥荒年里，粮食就是神。',
  },
  {
    index: 'XV',
    title: '雨落临安，刘家崩盘',
    cgKey: 'saga_015',
    excerpt:
      '第一滴雨落在他血红核桃上。啪。他抬头。第二滴、第三滴、千万滴。暴雨倾盆而下。整座临安府先是死寂，随后彻底沸腾。恐慌指数从七十二跌到十八。粮价像被砍断的绳，直直坠下。三天后，刘大户跪在庄园门前，地契抖得像秋风里的叶子。',
  },
  {
    index: 'XVII',
    title: '第一场庄园防御',
    cgKey: 'saga_017',
    excerpt:
      '火药桶点燃的那一刻，夜色猛地亮了一下。爆炸不大，却足够让从未见过火药的山匪魂飞魄散。火药负责制造声音和火光，他们自己的想象力负责补足剩下的杀伤。天亮时，七个俘虏跪在墙下。「回山报信，或者留下修墙、挖沟——干满三十日，给饭。」',
  },
  {
    index: 'XVIII',
    title: '活路变成旗帜',
    cgKey: 'saga_018',
    excerpt:
      '一个月前，沈家只有一间快塌的破屋；一个月后，后山荒滩绿了，仓库里有红薯干、有水泥、有火药。丫丫站在墙头：「哥，这里是不是我们的家了？」「是。」「你和嫂嫂在的地方，就是家。」我看着远处荒原：「现在是家。以后，会是城。」',
  },
];

export const dahuangDeveloperNote = {
  eyebrow: "DEVELOPER'S NOTE",
  title: '写给房车的幸存者，以及新来的朋友',
  paragraphs: [
    '在开发房车新版本的那些深夜里，我脑子里突然冒出了一个疯狂的想法：如果一个在房车末世里饱经风霜的现代人，带着脑子里的所有现代科学知识，穿越到了最残酷的古代大饥荒年代，会发生什么？',
    '这一次，我依然坚持单人开发（辅以 AI 提升产能）的兼职摸索模式。但有了《末世房车》积累的经验，新项目在玩法框架、数值反馈与模块解耦上会更加成熟。',
    '我希望带给大家最纯粹的「知识降维打击」快感。大到用化学公式配化肥，小到用信息差搞期票做空，我都尽量让它在具备游戏性的同时，有着符合逻辑的现实映射。',
  ],
  signature: '—— 光年切片工作室 敬上',
};

// 大荒「十二律」古风 BGM（12 首 · mp3）。曲目按情绪曲线排：茶馆 → 如梦 → 风雪 → 故乡 → 归大荒 → 荒原 → 惊雷 → 旷野 → 人间烟火 → 如故。
// 封面复用现有 NPC/CG 立绘，按曲意匹配。音频由 convert-dahuang-music.mjs 自 Ammonia 工程 WAV 转 128k mp3 而来。
export const dahuangSoundtrack = [
  { id: 'choutown', title: '村头茶馆', note: '粗茶一碗，听闻人间', file: getDahuangMusic('choutown'), cover: getDahuangImage('char_guqingyi') },
  { id: 'dream_bgm', title: '大荒如梦', note: '一梦入荒州，无弦唯有风声', file: getDahuangMusic('dream_bgm'), cover: getDahuangImage('npc_guqingyi_half') },
  { id: 'dream', title: '大荒如梦 · 沈凌', note: '沈凌 · 此身何往', file: getDahuangMusic('dream'), cover: getDahuangImage('npc_shenling_half') },
  { id: 'snow', title: '风雪归人 · 苏婉', note: '苏婉 · 踏雪叩门', file: getDahuangMusic('snow'), cover: getDahuangImage('npc_suwan_half') },
  { id: 'home', title: '故乡', note: '炊烟旧路，回不去是家', file: getDahuangMusic('home'), cover: getDahuangImage('npc_shenyaya_half') },
  { id: 'wasteland', title: '荒原', note: '千里无鸡鸣', file: getDahuangMusic('wasteland'), cover: getDahuangImage('npc_liudahu_half') },
  { id: 'thunder', title: '惊雷', note: '阴云压顶，天公怒', file: getDahuangMusic('thunder'), cover: getDahuangImage('npc_leiheng_half') },
  { id: 'song', title: '归大荒', note: '长歌叩问，此身何往', file: getDahuangMusic('song'), cover: getDahuangImage('promo_2') },
  { id: 'field', title: '旷野', note: '天地茫茫，一人独往', file: getDahuangMusic('field'), cover: getDahuangImage('promo_1') },
  { id: 'life', title: '人间烟火 · 顾清漪', note: '顾清漪 · 灯火可亲', file: getDahuangMusic('life'), cover: getDahuangImage('char_guqingyi') },
  { id: 'life_bgm', title: '人间烟火', note: '烟火无谱，却暖人心', file: getDahuangMusic('life_bgm'), cover: getDahuangImage('promo_3') },
  { id: 'rugu', title: '如故 · 沈凌 × 顾清漪', note: '故人相逢', file: getDahuangMusic('rugu'), cover: getDahuangImage('hero') },
];
